import React from 'react';

// ** Third Party Import
import { useTranslation } from 'react-i18next';

// ** Components
import PowerIconButton from '@erikdakoda/ui/components/PowerIconButton';

// ** Hooks
import { useCurrentUser } from '@erikdakoda/ui/hooks/useCurrentUser';
import { useUpdateUserFields } from '@erikdakoda/ui/hooks/useUpdateUserFields';

/**
 * Header control that toggles the signed-in user's `privacy` field
 * (whether private NamedItems are hidden from the owner on this screen).
 */
export default function PrivacyToggler() {
  'use memo';

  const { user } = useCurrentUser();
  const { updateUserFields, isLoading } = useUpdateUserFields();
  const { t } = useTranslation('site-template-ui');

  const updatePrivacy = async (privacy: boolean) => {
    await updateUserFields({ privacy }, privacy ? 'Privacy enabled' : 'Privacy disabled');
  };

  if (user === null) {
    return null;
  }

  return (
    <PowerIconButton
      className="privacy-toggler"
      size="small"
      icon={'vault'}
      hoverIcon={user?.privacy ? 'solid-vault-slash' : undefined}
      iconPrefix={user?.privacy ? 'fas' : undefined}
      color={user?.privacy ? 'info' : undefined}
      onClick={() => updatePrivacy(!user?.privacy)}
      disabled={false}
      loading={isLoading}
      title={
        user?.privacy ? (
          <>
            {t('privacyTogglerPrivateLabel')}
            <br />
            {t('privacyTogglerPrivateHint')}
          </>
        ) : (
          <>
            {t('privacyTogglerNotPrivateLabel')}
            <br />
            {t('privacyTogglerNotPrivateHint')}
          </>
        )
      }
    />
  );
}
